import { rest } from 'msw'
export default [
  /**
   * 媒体情報
   */
  rest.post('/api/v2/get_media_info', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          media: {
            mediaId: 1,
            menuType: 'round',
            menu: [
              {
                seq: 1,
                key: 'card',
                name: 'ポイントカード',
                color1: '#fff',
                color2: '',
                bgColor1: '#007aff',
                bgColor2: '#00c4ff',
              },
              {
                seq: 2,
                key: 'flyer',
                name: 'チラシ',
                color1: '#fff',
                color2: '',
                bgColor1: '#aa5f20',
                bgColor2: '#f28200',
              },
              {
                seq: 3,
                key: 'content',
                name: 'コンテンツ',
                color1: '#fff',
                color2: '',
                bgColor1: '#34c759',
                bgColor2: '#00ff40',
              },
              {
                seq: 4,
                key: 'pricing',
                name: 'ポイント特典',
                color1: '#fff',
                color2: '',
                bgColor1: '#ff3b30',
                bgColor2: '#ffa786',
              },
              {
                seq: 5,
                key: 'stamp',
                name: '買ったらスタンプ',
                color1: '#fff',
                color2: '',
                bgColor1: '#ff9500',
                bgColor2: '#ffd800',
              },
              {
                seq: 6,
                key: 'config',
                name: '設定',
                color1: '#fff',
                color2: '',
                bgColor1: '#ccc',
                bgColor2: '#eaeaea',
              },
            ],
            options: {
              liff_id: '1653929568-300ar6xA',
              copyright: '© 2020 HANKYU OASIS Co.,Ltd. All Rights Reserved',
            },
            cardSample:
              'https://static-stg.tokume.jp/assets/media/6/card_sample.png',
            cardUnlink:
              'https://static-stg.tokume.jp/assets/media/6/card_unlink.png',
            flyerSample:
              'https://static-stg.tokume.jp/assets/media/6/flyer_sample.png',
          },
          responseTime: '915148799',
        },
      })
    )
  }),
]
